define('views/modules/calendar/favorite/edit/favorite-edit-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/calendar/favorite',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/calendar/favorite/edit/favorite-edit-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    MFavorite,
    // views
    VBasePanel,
    VFavoriteEditContent
) {

    var VFavoriteEditPanel = VBasePanel.extend({
        header: {
            title: "Favorites",
            subtitle: "calendar:Adding/Modify a favorite",
        },
        tabs: [{ id: 'edit', title: 'Edit', icon: 'sl-icon-edit', active: true }],
        content: { edit: VFavoriteEditContent },
        defaultView: 'edit',

        initialize: function(opt) {
            opt = this.options = opt || {};

            this.model = new MFavorite({
                type: opt.type,
                data: opt.data
            });

            var edit = this.getView('edit', {
                model: this.model,
                item: opt.item
            });

            this.listenTo(edit, { 'form:success': this.onSuccess });
        },

        resetModel: function(attrs, options) {
            this.model.reset(_.extend({ type: this.options.type }, attrs), options);
            return this;
        },

        onSuccess: function(model) {
            this.trigger('form:success', model);
            this.close();
        },

    });

    return VFavoriteEditPanel;
});

